import apiClient from '../lib/axios';

export interface SystemHealth {
  database: 'healthy' | 'warning' | 'error';
  smsGateway: 'healthy' | 'warning' | 'error';
  dhis2: 'healthy' | 'warning' | 'error';
  smsSimulated: boolean;
}

export interface SystemMode {
  smsSimulated: boolean;
}

/**
 * Whether SMS sends are simulated is fixed when the backend boots and cannot
 * change while the app is open, so it is fetched once per page load. MainLayout
 * is mounted per route (see App.tsx), which would otherwise mean one request per
 * navigation just to decide whether to draw a banner.
 */
let modeRequest: Promise<SystemMode> | null = null;

class SystemService {
  /**
   * Cheap and static. Backed by /api/health, which does no database or upstream
   * probing, unlike getHealth() below.
   */
  async getMode(): Promise<SystemMode> {
    if (!modeRequest) {
      modeRequest = apiClient
        .get('/health')
        .then((response) => ({ smsSimulated: response.data.smsSimulated === true }))
        .catch((err) => {
          // Do not cache a failure, or one flaky request suppresses the
          // simulation banner for the rest of the session.
          modeRequest = null;
          throw err;
        });
    }
    return modeRequest;
  }

  /**
   * Full health probe: hits the database, DHIS2 and the SMS gateway. Used by
   * the Settings page only.
   */
  async getHealth(): Promise<SystemHealth> {
    const response = await apiClient.get('/health/detailed');
    return response.data.data;
  }
}

export const systemService = new SystemService();
